/*
This file is located in the main branch
Last time the file was updated (UTC): [11/6/2024 4:35:58AM]
Permissions to update outside the main branch: [false]
*/

import { DatePicker, DatePickerProps, useCondition } from '@finbeat/react-toolkit';
import { useGeneralSettingsContext } from 'providers/GeneralSettingsProvider';
import { useMemo } from 'react';
import { ReactDatePickerCustomHeaderProps } from 'react-datepicker';
import DatePickerHeaderNova from './Headers/DatePickerHeader.nova';

export const BODatePicker = <T,>(props: Omit<DatePickerProps<T>, 'displayDateFormat'>) => {
    const {
        dateTimeFormat,
        timeFormat,
        dateFormat: systemDisplayFormat,
        designType,
    } = useGeneralSettingsContext();

    const renderCustomHeader = useCondition(designType, { nova: NovaHeader }, undefined);

    const displayDateFormat = useMemo(() => {
        if (props.dateOnly) return systemDisplayFormat;
        return props.timeOnly ? timeFormat : dateTimeFormat;
    }, [props, systemDisplayFormat, timeFormat, dateTimeFormat]);

    return (
        <DatePicker<T>
            {...props}
            displayDateFormat={displayDateFormat}
            renderCustomHeader={renderCustomHeader}
        />
    );
};

const NovaHeader = (props: ReactDatePickerCustomHeaderProps) => <DatePickerHeaderNova {...props} />;
